import React from 'react';
import './ConstructionNotice.css';

const ConstructionNotice = () => {
  return (
    <div className="construction-notice">
      <h2>Notre site est actuellement en développement.</h2>
      <p>
        Nous travaillons à la mise en ligne d'un espace moderne, intuitif et 
        sécurisé pour mieux vous présenter nos services.
      </p>
      <p className="coming-soon">
        ⏳ Rendez-vous très bientôt pour découvrir le résultat !
      </p>
    </div>
  );
};

export default ConstructionNotice;

